
<template>
    <div id="flutter-view"></div>
</template>
<script>
// import { start3dView } from '@/scripts/Flutter/Flutter3d'
export default {
    name: 'FlutterView',
    mounted: function () {
        // start3dView();
    }
}
</script>